import { TitleCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PageHeader } from '@shared/interfaces/page-header.interface';
import { WhatsappIconComponent } from '@shared/components/whatsapp-icon/whatsapp-icon.component';

@Component({
  selector: 'app-page-header',
  imports: [
    TitleCasePipe,
    FontAwesomeModule,
    WhatsappIconComponent,
],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.css'
})
export class PageHeaderComponent {
  @Input({required: true}) headerInfo!: PageHeader;
}
